import { useDispatch, useSelector } from 'react-redux';

import {
  purchaseGiftCard as purchaseGiftCardAction,
  resetGiftCardState as resetGiftCardStateAction,
  startGiftCardFormLoading as startGiftCardFormLoadingAction,
  stopGiftCardFormLoading as stopGiftCardFormLoadingAction,
} from 'actions/GiftCardActions';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { getGiftCard } from 'selectors/gift-cards';

import { TGiftCardAPIPayload } from 'types/gift-card';

export const useGiftCards = () => {
  const giftCard = useSelector(getGiftCard);
  const dispatch = useDispatch<ThunkDispatch<any, any, AnyAction>>();

  const purchaseGiftCard = (data: TGiftCardAPIPayload) =>
    dispatch(purchaseGiftCardAction(data));

  const resetGiftCardState = () => dispatch(resetGiftCardStateAction());

  const startGiftCardFormLoading = () =>
    dispatch(startGiftCardFormLoadingAction());

  const stopGiftCardFormLoading = () =>
    dispatch(stopGiftCardFormLoadingAction());

  return {
    giftCard,
    purchaseGiftCard,
    resetGiftCardState,
    startGiftCardFormLoading,
    stopGiftCardFormLoading,
  };
};
